// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"b974172d","390":"6d3e2b25","453":"a7772595","963":"e6d2ecea"}[chunkId] + ".chunk.js";
};